import React, { useEffect } from "react";
import axios from "axios";
import ElementForm from "./ElementForm";


const myEnv = process.env
const protocole = myEnv.REACT_APP_SERVERPROTOCOLE
const host = myEnv.REACT_APP_SERVERHOSTNAME
const port = myEnv.REACT_APP_SERVERPORT
const apiIGLS = `${protocole}${host}:${port}`

// ElementEdit Component
const ElementDel = (params) => {
  const {typeElement, elem} = params


  useEffect(() => {
  }, [elem])

  //onSubmit handler
  const onSubmit = () => {
    console.log("Suppression")
    //console.log(elementCourant)

    const token = localStorage.getItem('token-access') ? localStorage.getItem('token-access') : ""
    const headers = {
      'accept': 'application/json',
      'x-access-token': token
     }

    console.log(`${apiIGLS}/${typeElement}/${elem.id}`)

    axios({
      //method post au lieu de put pour le file upload...
      method: 'delete',
      url:  `${apiIGLS}/${typeElement}/${elem.id}`,
      headers: headers,
    })
    .then((reponse) => {
      if (reponse.status === 200) {
        alert(`${typeElement} id ${elem.id} supprimé`);
        return
      }
      else Promise.reject()
    })
    .catch((erreur) => {
      if (erreur.response.status === 401){
        alert("Une erreur d'authentification a eu lieu lors de la suppression"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.response.data)
          console.log(erreur.response)
      } else if (erreur.response.status === 403){
        alert("Une erreur d'autorisation a eu lieu lors de la suppression"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.response.data)
          console.log(erreur.response)
      } else {
        alert("Une erreur a eu lieu lors de la suppression"
          + " de l'element de type "
          + typeElement
          + " Erreur : "
          + erreur.message)
      }
    })

  };

  return (
    <ElementForm
      typeAction="Supprimer"
      initialValues={elem}
      typeElement={typeElement}
      onSubmit={onSubmit}
      />
  )
}
export default ElementDel